// import { s8, createDiv, rectangle } from '@topology/core'
import {s8, createDiv} from '@topology/core'
var flvPlayerCreator = null
export function FlvPlayer(ctx, node) {
  // 绘制一个底图，类似于占位符
  // rectangle(ctx, node)
  if (!node.data) {
    return
  }
  if (typeof node.data === 'string') { // 解析data属性
    node.data = JSON.parse(node.data)
  }
  if (!node.data.data || !node.data.data.playUrl || !node.data.option) { // data/playUrl/option不允许为空
    return
  }
  if (node.elementId === undefined || node.elementId === null) {
    node.elementId = s8()
  }
  if (!node.elementLoaded) {
    // 创建一个div层
    let nodeDiv = createDiv(node)
    node.extDiv = nodeDiv
    document.body.appendChild(nodeDiv)
    node.addToDiv() // 添加当前节点到div层

    // 创建一个video
    let video = document.createElement('video')
    video.style.objectFit = 'fill'
    video.style.width = '100%'
    video.style.height = '100%'
    video.controls = node.data.option.hasOwnProperty('controls') ? !!node.data.option.controls : true
    video.autoplay = node.data.option.hasOwnProperty('autoplay') ? !!node.data.option.autoplay : false
    video.onerror = videoError
    if (node.elementId) {
      video.id = 'video' + node.elementId
    }
    video.nodeId = node.id
    video.url = node.data.data.playUrl
    node.extVideo = video
    nodeDiv.appendChild(video)

    createPlayer(video) // 创建一个flvjs对象
    node.extOnDestroy = doNodeDestroy // 关联处理节点销毁函数
    node.elementLoaded = true

    node.elementRendered = false
    // 等待父div先渲染完成调整尺寸
    setTimeout(function () {
      node.extDiv.style.x = node.rect.x + 'px'
      node.extDiv.style.y = node.rect.y + 'px'
      node.extDiv.style.width = node.rect.width + 'px'
      node.extDiv.style.height = node.rect.height + 'px'
    })
  } else {
  }

  if (!node.elementRendered) {
    // 初始化时，等待父div先渲染完成，避免初始图表控件太大。
    setTimeout(function () {
      console.log('node x:' + node.rect.x + ',div x:' + node.extDiv.style.x)
      node.extDiv.style.x = node.rect.x + 'px'
      node.extDiv.style.y = node.rect.y + 'px'
      node.extDiv.style.width = node.rect.width + 'px'
      node.extDiv.style.height = node.rect.height + 'px'
      node.elementRendered = true
      // setTimeout(function () {
      //     var img = new Image()
      //     img.src = flvPlayerObjs[node.id].player.getDataURL({
      //         pixelRatio: 2
      //     })
      //     node.img = img
      // }, 100)
    })
  } else {
  }
}

function createPlayer(video) {
  if (!flvPlayerCreator) {
    flvPlayerCreator = window.flvjs
  }

  if (!flvPlayerCreator || !video.url) {
    return
  }

  let player = flvPlayerCreator.createPlayer({ // 创建一个flvjs对象
    type: 'flv',
    url: video.url,
    hasAudio: false,
    hasVideo: true,
    isLive: true
  }, {
    enableWorker: true,
    enableStashBuffer: false,
    stashInitialSize: 128
  })

  player.attachMediaElement(video) // 关联video
  player.load() // 加载视频
  video.player = player

  return player
}

function destroyPlayer(video) {
  if (!video.player) {
    return
  }

  video.player.pause()
  video.player.unload()
  video.player.detachMediaElement()
  video.player.destroy()
  video.player = null
}

function videoError(e) {
  console.log('flv_error:' + e.target.error.code + ',' + e.target.error.message)
  if (e.target.error.code === 3) {
    destroyPlayer(e.target)
    createPlayer(e.target)
  }
}

// 处理节点销毁事件
function doNodeDestroy(node) {
  if (node.extVideo) {
    destroyPlayer(node.extVideo)
    if (node.extDiv) {
      let video = document.getElementById('video' + node.elementId)
      if (video) {
        node.extDiv.removeChild(video)
      }
    }
  }
}

// # sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./src/components/topologyDiagram/flvPlayer/flvJs/index.js